import { render } from "./ForbiddenPage.vue?vue&type=template&id=32e11082"
import script from "./ForbiddenPage.vue?vue&type=script&lang=js"
export * from "./ForbiddenPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__